jQuery(($) => {
  const loader = $('.bb-loader-wrapper');
  const allCheckbox = $('#price-list #all');
  const catCheckboxes = $('#price-list input[name="category"]');
  const submitBtn = $('#price-list button[type="submit"]');
  const errorMessageDiv = $('#price-list > .elementor-message');

  // let's handle the submit ourselves
  submitBtn.off();
  submitBtn.click((e) => handleSubmit(e));

  loader.fadeOut(100, () => loader.children('.notice').show());
  submitBtn.prop('disabled', false);

  // listen when the "all" checkbox is checked/unchecked
  allCheckbox.change((e) => {
    const $this = $(e.currentTarget);
    if ($this.prop('checked')) {
      catCheckboxes.prop('checked', true);
    } else {
      catCheckboxes.prop('checked', false);
    }
  });

  catCheckboxes.change((e) => {
    // if the 'all' cb is selected, toggle it off
    if (allCheckbox.prop('checked')) {
      allCheckbox.prop('checked', false);
      return;
    }
    // otherwise, check if all cat cbs are
    // checked and set the all cb to checked too
    for (const cb of catCheckboxes) {
      if (!$(cb).prop('checked')) {
        return;
      }
    }
    allCheckbox.prop('checked', true);
  });

  // listen to any kind of change in the price-list form
  $('#price-list').change((e) => {
    submitBtn.off();
    submitBtn.click((e) => handleSubmit(e));
  });

  // listen to submit
  $('#price-list').submit((e) => e.preventDefault());

  function handleSubmit(e) {
    e.preventDefault();
    const unparsedValues = $('#price-list').serializeArray();
    let selectedCategories = !allCheckbox.prop('checked')
      ? unparsedValues
          .reduce((carry, current) => {
            if (current.name === 'category') {
              carry.push(current.value);
            }
            return carry;
          }, [])
          .join(',')
      : 'all';

    if (selectedCategories.length === 0) {
      allCheckbox.prop('checked', true);
      allCheckbox.trigger('change');
      selectedCategories = 'all';
    }

    const discount = $('#price-list #discount').val()?.trim();
    const include_private = $('#include_private').val();

    getPriceList(selectedCategories, discount, include_private, {
      start: () => {
        loader.fadeIn(100);
        submitBtn.prop('disabled', true);
        errorMessageDiv.hide();
      },

      success: (blob, filename) => {
        try {
          if (typeof saveAs === 'undefined') {
            return handleError('saveAs is undefined!');
          }

          saveAs(blob, filename, {
            autoBom: true,
          });

          submitBtn.off();
          submitBtn.addClass('state:success');

          setTimeout(() => {
            submitBtn.removeClass('state:success');

            $(submitBtn).click((e) => {
              e.preventDefault();
              saveAs(blob, filename, {
                autoBom: true,
              });
            });
          }, 5000);
        } catch (error) {
          return handleError(error?.message ?? error);
        }
      },

      error: (error) => {
        handleError(error);
      },

      complete: () => {
        loader.fadeOut(100);
        submitBtn.prop('disabled', false);
      },
    });

    function handleError(error) {
      console.error(error);

      errorMessageDiv.css('display', 'flex');

      if (typeof Sentry !== 'undefined') {
        Sentry.captureException(error);
      }
    }
  }
});
